/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toUTCString();

    document.cookie = name + "=" + value + "; " + expires + "; path=/"
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}


let pagination = 1;
function fetchAllProducts() {
    let = allProducts = [],
      event = new Event('products:loaded');

    Promise.all([
        fetch(`/collections/all?view=linked&page=${pagination}`, {
            mode: 'no-cors',
            method: 'GET',
            credentials: 'include'
        })
    ]).then(async ([r]) => {
        return await r.text()
    }).then(data => {
        const products = JSON.parse(data)
        allProducts = [...allProducts, ...products]

        if (pagination === window.allPageCount) {
            localStorage.setItem('allProducts', JSON.stringify(allProducts)) // Save in localStorage
            window.products = JSON.parse(localStorage.getItem('allProducts')) // Save in window object
            setCookie('linkedFetched', true, 30)
            if (window.isProductPage) loadLinked();
        } else {
            pagination++
            fetchAllProducts(pagination)
        }
    })
}

// Fetch product if not saved already
if (!localStorage.getItem('allProducts') || !getCookie('linkedFetched')) {
    fetchAllProducts(pagination)
} else {
    window.products = JSON.parse(localStorage.getItem('allProducts'))

    // Check if product count has changed
    if (window.allProductsCount === window.products.length) {
        if (window.isProductPage) loadLinked();
    } else fetchAllProducts(pagination)
}

function getSkuProduct(sku) {
    let skuColor, skuProduct, skuProductAChar = ""

    if ( sku === '' ) return;

    sku = sku.split('-')
    skuColor = sku[1].split('_')[0]

    let splitColorCharacters = skuColor.split('')
    splitColorCharacters.forEach(c => {
        if (parseInt(c) || c == "0") {
            skuProductAChar += c
        }
    })

    return sku[0] + "-" + skuProductAChar
}

function getSkuColor(sku) {
    let skuColor = "", skuProduct, skuProductAChar = ""
    const reg = /[^A-Za-z]/g

    // get SKU piece including color
    skuParts = sku.split('-')
    skuParts.length > 1 ? sku = skuParts[2] : sku = skuParts[0]

    // some SKUs are structured wrong, so fix them
    sku = sku.split('_')[0]

    // remove all numbers/specials from color
    skuColor = sku

    // sku = sku.split('-')

    // let splitColorCharacters = sku[1].split('_')[0].split('')

    // splitColorCharacters.forEach(c => {
    //     if (!parseInt(c) || c !== "0") {
    //         skuColor += c
    //     }
    // })

    return skuColor
}


// Listen for the event.
function loadLinked() {
    let linkedContainer = document.querySelector('.product__linked'),
        sku = getSkuProduct(document.body.dataset.sku),
        prods = window.products


    const linked = prods.filter(i => getSkuProduct(i.sku) === sku)

    linked.forEach((l, i) => {
        let lSku = getSkuProduct(l.sku),
            prodHTML
            
        //console.log({sku: l.sku, color: getSkuColor(l.sku)})

        if (l.sku === document.body.dataset.sku) prodHTML = '<div title="' + l.title + '" class="product__linked-item active swatch-' + getSkuColor(l.sku) + '"></div>'
        else prodHTML = '<a title="' + l.title + '" href="/products/' + l.handle + '" class="product__linked-item swatch-' + getSkuColor(l.sku) + '"></a>'
        linkedContainer.insertAdjacentHTML('beforeend', prodHTML)
    })
}

/**
 * Sizeguide modal
 */

var sizeTrigger = document.querySelector('[data-size-trigger]')

if (sizeTrigger) {
    var close = document.querySelector('[data-size-close]')
    var sizeModal = document.querySelector('[data-size]')
    var outer = document.querySelector('[data-outer]')

    sizeTrigger.addEventListener('click', function (event) {
        document.documentElement.classList.add('no-scroll');
        sizeModal.classList.add('is-open')
    })

    close.addEventListener('click', function (event) {
        event.preventDefault();

        sizeModal.classList.remove('is-open')
        document.documentElement.classList.remove('no-scroll')
    })

    document.addEventListener('click', function (event) {
        if (!outer.contains(event.target) && event.target != sizeTrigger) {
            sizeModal.classList.remove('is-open')
            document.documentElement.classList.remove('no-scroll')
        }
    })
}

var submit = document.querySelector('form button.Cart__Checkout'),
    terms = document.querySelector('[data-terms]'),
    popup = document.querySelector('.js-popup');

const accept = popup.querySelector('.js-accept')
const cancel = popup.querySelector('.js-cancel')

accept.addEventListener('click', () => {
    popup.classList.remove('open')
    terms.checked = true
    location.href = "/checkout"
})

cancel.addEventListener('click', () => {
    popup.classList.remove('open')
})